import { Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom';
import RouteErrorBoundary from '../components/routeErrorBoundary/RouteErrorBoundary';
import SupportAssistance from '../pages/supportAssistance/SupportAssistance';
import SupHeader from '../webPageSections/supPageSection/supHeader/SupHeader';
import Footer from '../webPageSections/footer/Footer';
import BlogUpload from '../pages/blogUpload/BlogUpload';
import { useContext, useEffect, useState } from 'react';
import { SupAuthContext } from '../context/SupAuthContext';
import SupLoginPage from '../pages/supLoginPage/SupLoginPage';
import SupAccount from '../pages/supAccount/SupAccount';
import SupLeftMenu from '../components/supLeftMenu/supLeftMenu';
import SupTickets from '../pages/supTickets/supTickets';
import SupTicketsDetails from '../pages/supTickets/details/supTicketsDetails';
import AddTickets from '../pages/supTickets/addTicket/addTickets';
import BlogList from '../pages/blog/BlogList';
import OffersList from '../pages/supOffers/supOffers';
import OffersUpload from '../pages/supOffers/addOffers/addOffers';
import DropdownList from '../pages/supDropdown/supDropdown';
import DropdownUpload from '../pages/supDropdown/addDropdowns/addDropdown';
import { toast } from 'react-toastify';
import SupPayments from '../pages/supPayments/supPayments';
import ApprovalsList from '../pages/supApprovals/supApprovals';
import SupFaq from '../pages/supFAQ/supFAQ';
import AddFaq from '../pages/supFAQ/addFaq/addFaq';
import SupApprovalDetails from '../pages/supApprovals/supApprovalDetails/supApprovalDetails';
import SupTripDateDetails from '../pages/supTripDateDetails/SupTripDateDetails';
import SupOrgTripDetails from '../pages/supOrgTripDetails/SupOrgTripDetails';
import SupOrgSlotDetails from '../pages/supSlotDetails/SupSlotDetails';
import { SupOrgDatesProvider } from '../context/SupOrgDatesContest';
import OrgAccount from '../pages/supOrgAccount/OrgAccount';
import SupOrgAccEdit from '../pages/supOrgAccEdit/SupOrgAccEdit';
import SupTripCustomDateDetails from '../pages/supTripDateDetails/supTripCustomDateDetails/supTripCustomDateDetails';
import SupAbandonBookings from '../pages/supAbandonBookings/SupAbandonBookings';
import Reporting from '../pages/reporting/Reporting';
import SupDashboard from '../pages/supDashboard/SupDashboard';
import SupOrgPackList from '../pages/supOrgPackList/SupOrgPackList';
import SupBooking from '../pages/supBooking/SupBooking';
import SupPaymentsTab from '../pages/supBilling/supPaymentsTab';
import SupOrgRegister from '../pages/supOrgRegister/SupOrgRegister';
import SupportPackUploadWrapper from '../pages/supPackUpload/SupportPackUploadWrapper';
import SupOrgDetailsWrapper from '../pages/supOrgTripDetails/SupOrgDetailsWrapper';
import AddBookingOthers from '../components/addBookingOthers/AddBookingOthers';
import AddBookingSup from '../components/addBookingSup/AddBookingSup';
import SupRating from '../pages/supRating/SupRating';
import SupBookingEdit from '../pages/supBookingEdit/SupBookingEdit';
import ChatbotUsers from '../pages/supChatBot/SupChatBot';
import SupNotification from '../pages/supNotification/SupNotification';
import NotificationHistory from '../pages/supNotification/NotificationHistory';
import SearchKeywords from '../pages/searchKeywords/SearchKeywords';
import AppVersions from '../pages/supVersion/AppVersions';
import SupAnalytics from '../pages/supAnalytics/SupAnalytics';
import SupFinance from '../pages/supFinance/SupFinance';
import SupCalls from '../pages/supCalls/SupCalls';

const supClearItems = ['supName', 'supId', 'supToken', 'supExpiry', 'supAccess', 'sup'];

export default function SupportLayout() {
    const { isSupAuthenticated } = useContext(SupAuthContext);
    const [addBo, setAddBo] = useState(false);
    // t / a / c / g (or admin). Pages keep their data in state, so when the type
    // changes in the URL the page must start fresh - otherwise e.g. camp rows are
    // rendered by the trip table for a moment and the page crashes (blank until refresh).
    const { mode } = useParams();
    const { pathname } = useLocation();
    const isLoginExpiredSup = () => {
        const expiryTime = Number(window.localStorage.getItem('supExpiry'));
        return expiryTime && Date.now() > expiryTime;
    };

    const monitorLoginExpirySup = () => {
        const interval = setInterval(() => {
            if (window.location.pathname !== '/support/login') {
                if (isLoginExpiredSup()) {
                    toast.error('Session has expired. Login again to continue');
                    setTimeout(() => {
                        supClearItems.forEach((key) => {
                            localStorage.removeItem(key); // Removes the specified key
                        }); // Clear all local storage
                        clearInterval(interval); // Stop further checks
                        window.location = '/support/login';
                    }, 3000);
                }
            }
        }, 10000); // Check every 10 seconds
    };

    useEffect(() => {
        monitorLoginExpirySup();
        //eslint-disable-next-line
    }, []);

    return (
        <>
            {isSupAuthenticated ? (
                <>
                    <SupHeader setAddBo={setAddBo} />
                    <div className='org-main-container'>
                        <SupLeftMenu />
                        <main className='org-content'>
                            <RouteErrorBoundary resetKey={pathname}>
                                <Routes key={mode || ''}>
                                    {/* <Route
                                    path="/login"
                                    element={<SupLoginPage />}
                                /> */}
                                    <Route path='/customer-support' element={<SupportAssistance />} />
                                    <Route path='/tickets' element={<SupTickets />} />
                                    <Route path='/addTickets' element={<AddTickets />} />
                                    <Route path='/tickets/:id' element={<SupTicketsDetails />} />
                                    {/* <Route path='/account' element={<SupAccount />} /> */}
                                    <Route path='/blogs' element={<BlogList />} />
                                    <Route path='/blog/upload' element={<BlogUpload />} />
                                    <Route path='/blog/edit/:id' element={<BlogUpload />} />
                                    <Route path='/offers' element={<OffersList />} />
                                    <Route path='/offers/upload' element={<OffersUpload />} />
                                    <Route path='/:type' element={<DropdownList />} />
                                    <Route path='/:type/upload' element={<DropdownUpload />} />
                                    <Route path='/payments' element={<SupPayments />} />
                                    <Route path='/approvals' element={<ApprovalsList />} />
                                    <Route path='/analytics' element={<SupAnalytics />} />
                                    <Route path='/finance' element={<SupFinance />} />
                                    <Route path='/report' element={<Reporting />} />
                                    <Route path='/chatbot' element={<ChatbotUsers />} />
                                <Route path='/staff-calls' element={<SupCalls />} />
                                    <Route path='/app-notification' element={<SupNotification />} />
                                    <Route path='/app-versions' element={<AppVersions />} />
                                    <Route path='/notifications/history' element={<NotificationHistory />} />
                                    <Route path='/search-keywords' element={<SearchKeywords />} />
                                    <Route
                                        path='/approvals/details/:id'
                                        element={
                                            <SupOrgDatesProvider>
                                                <SupApprovalDetails />
                                            </SupOrgDatesProvider>
                                        }
                                    />
                                    <Route path='/abandon' element={<SupAbandonBookings />} />
                                    <Route path='/faq' element={<SupFaq />} />
                                    <Route path='/faq/upload' element={<AddFaq />} />
                                    <Route path='/bookings/:orgId?' element={<SupBooking />} />
                                    <Route path='/org/account/:orgId?' element={<OrgAccount />} />
                                    <Route path='/org/account/register' element={<SupOrgRegister />} />
                                    <Route path='/billings/:orgId?' element={<SupPaymentsTab />} />
                                    <Route path='/payouts/:orgId?' element={<SupPaymentsTab />} />
                                    <Route path='/create/pack/:orgId' element={<SupportPackUploadWrapper />} />
                                    <Route path='/dashboard/:orgId?' element={<SupDashboard />} />
                                    <Route
                                        path='/details/:orgId?/:tripId?'
                                        element={
                                            <SupOrgDatesProvider>
                                                <SupOrgDetailsWrapper />
                                            </SupOrgDatesProvider>
                                        }
                                    />
                                    <Route path='/trip/date/:orgId/:tripDateId' element={<SupTripDateDetails />} />
                                    <Route path='/date/:orgId/:dateId/:slotId' element={<SupOrgSlotDetails />} />
                                    <Route path='/date/:orgId/:packid/:date' element={<SupTripCustomDateDetails />} />
                                    <Route path='/packages/:orgId?' element={<SupOrgPackList />} />
                                    <Route path='/account' element={<SupAccount />} />
                                    <Route path='/rating' element={<SupRating />} />
                                    <Route path='/org/edit/:orgId?' element={<SupOrgAccEdit />} />
                                    <Route path='/booking/edit' element={<SupBookingEdit />} />
                                    <Route path='*' element={<Navigate to='customer-support' />} />
                                </Routes>
                            </RouteErrorBoundary>
                        </main>
                        <Footer />
                    </div>
                    {addBo && <AddBookingSup setAddBo={setAddBo} />}
                </>
            ) : (
                <Routes>
                    <Route path='/login' element={<SupLoginPage />} />
                    <Route path='/*' element={<Navigate to='login' />} />
                </Routes>
            )}
        </>
    );
}
